import { render, staticRenderFns } from "./fileBrowser.vue?vue&type=template&id=3f155920&scoped=true&lang=pug&"
import script from "./fileBrowser.vue?vue&type=script&lang=js&"
export * from "./fileBrowser.vue?vue&type=script&lang=js&"
import style0 from "./fileBrowser.vue?vue&type=style&index=0&id=3f155920&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f155920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3f155920', component.options)
    } else {
      api.reload('3f155920', component.options)
    }
    module.hot.accept("./fileBrowser.vue?vue&type=template&id=3f155920&scoped=true&lang=pug&", function () {
      api.rerender('3f155920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/others/fileBrowser.vue"
export default component.exports